export default __webpack_public_path__ + "static/media/background-login.0689eb65.svg";